<template>
  <!-- SelectItem do app: texto à esquerda e o quadradinho à direita (laranja com check quando escolhido) -->
  <button type="button" class="app-check-row d-flex align-items-center w-100 text-start text-primary" :class="{ checked }" @click="emit('click')">
    <span class="text-paragraph flex-grow-1 d-flex align-items-center flex-wrap gap-2">
      {{ label }}
      <slot name="extra" />
    </span>
    <span class="app-check-row-box"><span v-if="checked" class="fas fa-check"></span></span>
  </button>
</template>

<script setup lang="ts">
defineProps<{ label: string; checked?: boolean }>();
const emit = defineEmits<{ click: [] }>();
</script>

<style scoped lang="scss">
@import "@/assets/theme/scss/user-variables";

.app-check-row {
  gap: 16px;
  padding: 20px 0;
  background: transparent;
  border: 0;
  border-bottom: 1px solid $primary10;
}

.app-check-row-box {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid $primary25;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: $white;
  font-size: 12px;
}

.app-check-row.checked .app-check-row-box {
  background: $secondary;
  border-color: $secondary;
}
</style>
